import { create } from 'zustand';
const useSceneOutput = create(() => ({
    scenes: [],
    liveSceneId: undefined,
    displaySceneId: undefined,
    thumbnails: {},
    canvasKeys: {},
}));
const reactiveOutput = {
    useScenes: () => {
        return useSceneOutput((s) => s.scenes);
    },
    useLiveSceneId: () => {
        return useSceneOutput((s) => s.liveSceneId);
    },
    useLiveScene: () => {
        return useSceneOutput((s) => s.scenes.find((scene) => scene.id === s.liveSceneId));
    },
    useDisplaySceneId: () => {
        return useSceneOutput((s) => s.displaySceneId);
    },
    useDisplayScene: () => {
        return useSceneOutput((s) => {
            if (s.displaySceneId) {
                return s.scenes.find((scene) => scene.id === s.displaySceneId);
            }
            if (s.liveSceneId) {
                return s.scenes.find((scene) => scene.id === s.liveSceneId);
            }
            return s.scenes[0];
        });
    },
    useThumbnails: () => {
        return useSceneOutput((s) => s.thumbnails);
    },
    useCanvasKeys: () => {
        return useSceneOutput((s) => s.canvasKeys);
    },
};
export class SceneServiceOutput {
    static getReactiveOutput() {
        return reactiveOutput;
    }
    getLiveSceneId() {
        return useSceneOutput.getState().liveSceneId;
    }
    getDisplaySceneId() {
        return useSceneOutput.getState().displaySceneId;
    }
    setScenes(scenes) {
        useSceneOutput.setState({ scenes });
    }
    setLiveSceneId(liveSceneId) {
        useSceneOutput.setState({ liveSceneId });
    }
    setDisplaySceneId(displaySceneId) {
        useSceneOutput.setState({ displaySceneId });
    }
    setThumbnails(thumbnails) {
        useSceneOutput.setState({ thumbnails });
    }
    setThumbnail(sceneId, dataUrl) {
        useSceneOutput.setState((s) => ({
            thumbnails: { ...s.thumbnails, [sceneId]: dataUrl },
        }));
    }
    rekeySceneCanvas(sceneId) {
        useSceneOutput.setState((s) => ({
            canvasKeys: {
                ...s.canvasKeys,
                [sceneId]: (s.canvasKeys[sceneId] || 0) + 1,
            },
        }));
    }
}
